import "core-js/modules/es.array.push.js";
export default {
  computed: {
    token() {
      return this.$store.state.token;
    }
  },
  watch: {
    token(newVal) {
      this.getData();
    }
  },
  mounted() {
    // this.getData();
  },
  methods: {
    // 时间格式化
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    getData() {
      this.loading = true;
      // 累计积温曲线图
      let params = {
        officeCode: "dandong",
        startTime: "2023-01-01",
        endTime: "2023-12-31"
      };
      this.$api_tieling.getAccumlatedData(params).then(res => {
        let data3 = []; //累计积温
        let data4 = []; //预测积温
        let data5 = []; //时间轴横轴
        let data6 = []; //关键节点显示颜色数组
        let alldata = []; //所有数据
        let date = this.getNowFormatDate();
        res.weatherHistoryList.map(i => {
          // data3.push(i.activeAccumulatedTemperature);
          // data4.push(i.activeAccumulatedTemperature);

          // 判断4月3日之前不显示
          if (i.recordTime >= "2022-03-20") {
            // 判断数据存在 >=0显示
            if (i.activeAccumulatedTemperature >= 0 && i.activeAccumulatedTemperature != undefined && i.activeAccumulatedTemperature != '') {
              alldata.push(i);
              data5.push(i.recordTime);
              // 生长周期关键节点
              // if (i.isFirstStage == 1) {
              //   data6.push(i.activeAccumulatedTemperature);
              //   data3.push("");
              //   data4.push("");
              // } else {
              data6.push("");
              // 累计及预测的拐点信息
              if (i.recordTime < date) {
                data3.push(i.activeAccumulatedTemperature);
                data4.push("");
              } else {
                data4.push(i.activeAccumulatedTemperature);
                data3.push("");
              }
              // }
            }
          }
        });

        this.loading = false;
        this.initCharts(data3, data4, data5, data6, date, alldata);
        console.log(alldata, "alldata");
        // localStorage.setItem('jiwen', JSON.stringify(alldata[alldata.length-1]) )
      });
    },

    initCharts(data3, data4, data5, data6, date, alldata) {
      console.log(data3, data4, data5, "data5");
      var chartDom3 = this.$refs.chart;
      var myChart3 = this.$echarts.init(chartDom3);
      var option3 = {
        grid: {
          x: 60,
          x2: 20,
          y: 30,
          y2: 30
        },
        tooltip: {
          trigger: "axis",
          // 设置触发类型为坐标轴轴线触发
          axisPointer: {
            type: "line" // 设置坐标轴指示器为直线
          }
        },

        xAxis: {
          type: "category",
          data: data5,
          axisLine: {
            lineStyle: {
              color: "#fff"
            }
          },
          boundaryGap: false
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
            lineStyle: {
              color: "#fff"
            }
          },
          axisLabel: {
            formatter: "{value} °C"
          },
          splitLine: {
            lineStyle: {
              color: "gray"
            }
          }
        },
        legend: {
          data: ["累积积温", "预计积温"],
          textStyle: {
            color: "#fff"
          }
        },
        series: [{
          name: "累积积温",
          type: "line",
          smooth: true,
          // 线是圆滑的、
          showAllSymbol: true,
          symbolSize: 5,
          showSymbol: false,
          data: data3,
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 1,
              x2: 0,
              y2: 0,
              colorStops: [{
                offset: 0,
                color: "rgba(161, 184, 35, 0.2)" // 0% 处的颜色
              }, {
                offset: 1,
                color: "rgba(161, 184, 35, 1)" // 100% 处的颜色
              }],

              global: false // 缺省为 false
            }
          },

          lineStyle: {
            color: "rgba(34, 255, 204, 1)"
          }
        }, {
          name: "预计积温",
          type: "line",
          smooth: true,
          // 线是圆滑的、
          showAllSymbol: true,
          // symbolSize: 5,
          showSymbol: false,
          data: data4,
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 1,
              x2: 0,
              y2: 0,
              colorStops: [{
                offset: 0,
                color: "rgba(34, 154, 255, 0.2)" // 0% 处的颜色
              }, {
                offset: 1,
                color: "rgba(34, 154, 255, 1)" // 100% 处的颜色
              }],

              global: false // 缺省为 false
            }
          },

          lineStyle: {
            color: "rgba(0, 102, 210, 1)"
          }
        }
        // {
        //   name: "累积积温",
        //   data: [150, 230, 224, 218, 135, 147, 260],
        //   type: "line",
        //   stack: "Total",
        //   symbol: "none",
        //   smooth: true,
        //   areaStyle: {
        //     color: "#30c0a180",
        //   },
        //   emphasis: {
        //     focus: "series",
        //   },
        //   lineStyle: {
        //     color: "#22FFCC",
        //   },
        // },
        // {
        //   name: "预计积温",
        //   data: [50, 100, 264, 198, 195, 177, 260],
        //   type: "line",
        //   stack: "Total",
        //   symbol: "none",
        //   smooth: true,
        //   areaStyle: {
        //     color: "#30c0a180",
        //   },
        //   emphasis: {
        //     focus: "series",
        //   },
        //   lineStyle: {
        //     color: "#229AFF",
        //   },
        // },
        ]
      };

      myChart3.setOption(option3);
    }
  }
};